import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  ViewChild,
  ElementRef,
  DoCheck
} from "@angular/core";
import { IGridSettings, PaginationSetting, SortOrder, SortConfiguration, ColumnType } from "./grid.model";
import { DatePipe } from "@angular/common";
import { AppConfig } from "@app/core/Utilities/app-config.service";
import { DropDownFilter, ReferralCommissionModel } from '@app/core/models/referral-management-model';
import { ReferralService } from '@app/core/services/referral.api.service';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { PopoverDirective } from 'ngx-bootstrap/popover';

@Component({
  selector: "app-grid",
  templateUrl: "./grid.component.html",
  styleUrls: ["./grid.component.scss"]
})
export class GridComponent implements OnInit, OnChanges, DoCheck {
  public _gridSettings: IGridSettings;
  public showAction: boolean = true;
  public serverUrl: string;

  public showPagination: boolean = false;
  public paginationSetting: PaginationSetting;

  // For refferral Commission
  public commissionSubmited: boolean = false;
  public commissionReferralId: any;
  public referralCommissionForm: FormGroup;
  public budgetPattern: string = '^[0-9.]+$';

  @ViewChild("deleteConfirmation") deleteConfirmation: ElementRef;
  private deleteConfirmationId: any;

  modalRef: BsModalRef;
  @ViewChild("commissionConfirmation") commissionConfirmation: ElementRef;

  // defalut settings
  defaultSettings: IGridSettings = {
    title: "",
    columns: [],
    showDropdownFilter: false,
    showIndex: true,
    showDownload: false,
    showViewDetails: false,
    showPagination: false,
    showDurationDropdownFilter: false
  };
  defaultPaginationSetting: PaginationSetting = {
    currentPage: 1,
    totalRecords: 50,
    itemPerPage: 5,
    selectedPageSize: ["50"]
  }

  public commissionModel: boolean = false;

  isDateVisible = true;
  startDate: Date;
  endDate: Date;
  @ViewChild("popoverRef") private _popoverRef: PopoverDirective;
  @Input() showDateRangePicker = false;
  @Output() dateSelection = new EventEmitter();

  @Input() data: any[];
  @Input() dropDownFilter: DropDownFilter;
  @Input() durationDropDownFilter: DropDownFilter;
  @Input() isLoading: boolean = false;
  @Input() downloadUrl: string;
  @Input()
  public set gridSettings(value: IGridSettings) {
    if (value) {
      this._gridSettings = Object.assign(this.defaultSettings, value);

      if (value.showPagination != undefined && value.showPagination) {
        this.showPagination = value.showPagination;
      }
    } else {
      this._gridSettings = Object.assign(this.defaultSettings);
    }

  }

  @Input()
  public set paginationSettings(value: PaginationSetting) {
    if (value) {
      this.paginationSetting = Object.assign(this.defaultPaginationSetting, value);
    } else {
      this.paginationSetting = Object.assign(this.defaultPaginationSetting);
    }
  }

  @Output() download = new EventEmitter();
  @Output() viewDetails = new EventEmitter();
  @Output() deleteNotification = new EventEmitter();
  @Output() onPageChange = new EventEmitter<PaginationSetting>();
  @Output() onSort = new EventEmitter<SortConfiguration>();
  @Output() onDropdownChange = new EventEmitter<string>();
  @Output() onDurationDropdownChange = new EventEmitter<string>();
  @Output() onRefreshGridData = new EventEmitter();

  /*---------------Sorting : Start -----------------------*/
  public sortOrder = SortOrder.ASC;
  public previousSort: string = "";
  public previousSortOrder = SortOrder.Default;

  sort(ev: string, sort: boolean) {
    if (sort) {
      if (ev === this.previousSort) {
        this.sortOrder = this.previousSortOrder == SortOrder.ASC ? SortOrder.DESC : SortOrder.ASC;
      } else {
        this.sortOrder = SortOrder.ASC;
      }
      this.previousSort = ev;
      this.previousSortOrder = this.sortOrder;
      let sortDetail: SortConfiguration = new SortConfiguration();
      sortDetail.sort = ev;
      sortDetail.sortOrder = this.sortOrder

      this.onSort.emit(sortDetail);
    }
  }

  sortUp(columnName) {
    return this.previousSort == columnName && this.previousSortOrder == SortOrder.DESC;
  }

  sortDown(columnName) {
    return this.previousSort == columnName && this.previousSortOrder == SortOrder.ASC;
  }

  sortDefault(columnName) {
    return this.previousSortOrder == SortOrder.Default || this.previousSort != columnName;
  }
  /*---------------Sorting : End-----------------------*/


  /*---------------Dropdowns : Start-----------------------*/
  onDropdownFilterChange(selectedText: any) {
    if (this.dropDownFilter.DisplayText != selectedText) {
      this.onDropdownChange.emit(selectedText);
      this.dropDownFilter.DisplayText = selectedText;
    }
  }

  onDurationDropdownFilterChange(selectedText: any) {

    if (this.durationDropDownFilter.DisplayText != selectedText) {
      this.onDurationDropdownChange.emit(selectedText);
      this.durationDropDownFilter.DisplayText = selectedText;
    }
  }
  /*---------------Dropdowns : End-----------------------*/

  ngOnChanges(changes: any) { }

  constructor(private datePipe: DatePipe, private _appConfig: AppConfig,
    private modalService: BsModalService,
    private _referralService: ReferralService, private _toaster: ToastrService, private formBuilder: FormBuilder) {
    this.serverUrl = this._appConfig.baseUrl;
  }

  ngOnInit() {

    this.showAction = this._gridSettings.showDownload || this._gridSettings.showViewDetails || this._gridSettings.showDelete || this._gridSettings.showInformationPopover;
    this.setRefferalCommissionForm();
  }

  //when page changed from paging menu
  pageChange(event: any) {

    this.previousSort = "";
    this.previousSortOrder = SortOrder.Default;
    this.paginationSetting.currentPage = event.page;
    this.onPageChange.emit(this.paginationSetting);
  }

  transformDate(date, format: string) {
    // if (format === undefined || format == null) {
    //   format = "MM/dd/yyyy h:mm:ss a";
    // }
    // return this.datePipe.transform(date, format);
    if (format == ColumnType.SHORTDATE) {
      format = "MM/dd/yyyy";
    } else if (format == ColumnType.LONGDATE) {
      format = "M/d/yy, h:mm a";
    } else {
      format = "M/d/yy, h:mm a";
    }

    return this.datePipe.transform(date, format);
  }

  setRefferalCommissionForm() {
    this.referralCommissionForm = this.formBuilder.group({
      commissionAmount: new FormControl('', [
        Validators.required,
        Validators.pattern(this.budgetPattern)
      ]),
      isCommissionReceived: "true"
    });
  }

  openReferralCommissionModal(referralId: any) {
    this.commissionSubmited = false;
    this.commissionReferralId = referralId;
    this.commissionModel = false;
    this.referralCommissionForm.reset();
    this.referralCommissionForm.get("isCommissionReceived").patchValue("false");
    this.modalRef = this.modalService.show(this.commissionConfirmation, Object.assign({}, { class: 'custom-modal update-modal modal-lg' }));
    // this._modalService.open(content, { ariaLabelledBy: "modal-basic-title"}).result.then(result => {},reason => {});
  }

  updateCommissionAmount() {

    this.commissionSubmited = true;
    if (this.referralCommissionForm.controls.isCommissionReceived.value == "true" && this.referralCommissionForm.invalid) {
      return
    }

    let transactionAmount = 0;
    transactionAmount = parseFloat(this.referralCommissionForm.controls.commissionAmount.value) ? parseFloat(this.referralCommissionForm.controls.commissionAmount.value) : 0;
    let commissionModel = new ReferralCommissionModel();
    commissionModel.ReferralID = this.commissionReferralId;
    commissionModel.TransactionAmount = transactionAmount;
    commissionModel.TransactionStatus = this.referralCommissionForm.controls.isCommissionReceived.value == "true";
  
    this.onReferralCommissionUpdate(commissionModel);
  }  
 
  onReferralCommissionUpdate(referralCommissionModel: ReferralCommissionModel) {

    this._referralService.updateReferralCommission(referralCommissionModel).subscribe(
      (response: any) => {
        this._toaster.success('Referral Commission Updated Successfully.');
        this.onRefreshGridData.emit();
        this.modalRef.hide();
      },
      error => {
        this._toaster.error('Something went wrong! Please try after sometime.');
      }
    );
  }

  showSortByForMobile(): boolean {
    return _.find(this._gridSettings.columns, function (o) { return o.sort == true; }) ? true : false;
  }


  openDeleteConfirmation(recordID: any) {

    this.deleteConfirmationId = recordID;
    this.modalRef = this.modalService.show(this.deleteConfirmation, Object.assign({}, { class: 'custom-modal update-modal modal-lg' }));
  }

  deleteRecord() {
    this.modalRef.hide();
    this.deleteNotification.emit(this.deleteConfirmationId);
  }

  showGridTitle(title: any) {
    return title ? title + ':' : '';
  }

  ngDoCheck() {
    if (this.showDateRangePicker == false) {
      this.startDate = void(0);
      this.endDate = void(0);
    }
    if (document.getElementsByTagName("popover-container").length) {
      document
        .getElementsByTagName("popover-container")[0]
        .classList.add("popover-datepicker");
    }
  }

  dateSelectionDone() {
    this.isDateVisible = false;
  }

  showDate() {
    this.isDateVisible = true;
  }

  getStartDatetoShow(date: any) {
    return date
      ? this.datePipe.transform(date, "yyyy-MM-dd")
      : this.datePipe.transform(this.startDate, "yyyy-MM-dd");
  }

  getEndDatetoShow(date: any) {
    return date
      ? this.datePipe.transform(date, "yyyy-MM-dd")
      : this.datePipe.transform(this.endDate, "yyyy-MM-dd");
  }

  minDateSelectionDone(event) {
    this.startDate = event;
    this.endDate = void (0);
    this.dateSelectionDone();
    this.dateSelection.emit({ startDate: this.getStartDatetoShow(this.startDate), endDate: this.getEndDatetoShow(this.endDate) });
  }

  maxDateSelectionDone(event) {
    this.endDate = event;
    this.dateSelectionDone();
    this.dateSelection.emit({ startDate: this.getStartDatetoShow(this.startDate), endDate: this.getEndDatetoShow(this.endDate) });
  }

  close() {
    this._popoverRef.hide();
  }
}
